const urlSearch = () => {
  const parameters = {};
  const pairs = window.location.search.slice(1).split('&');

  for (const item of pairs) {
    const pair = item.split('=');
    const key = pair[0];
    parameters[key] = pair[1] && decodeURIComponent(pair[1]);
  }
  return parameters;
};

export default urlSearch;
